export const Flux = {
  "name": "FLUX.1-schnell",
  "params": [
      {
        label: "Seed",
        name: "seed",
        desc: "The seed to use for the random number generator. Changing this will produce different results.",
        min: 0,
        max: 12013012031030,
        step: 1,
        default: 4775002255836,
        long: true,
      },
      {
        label: "Width",
        name: "width",
        desc: "The width of the image to generate.",
        min: 128,
        max: 768,
        step: 1,
        default: 512,
      },
      {
        label: "Height",
        name: "height",
        desc: "The height of the image to generate.",
        min: 128,
        max: 768,
        step: 1,
        default: 512,
      },
      {
        label: "Guidance Scale",
        name: "guidanceScale",
        desc: "How closely your prompt should be followed. Use a lower value for more creativity, and a higher value for more precision.",
        min: 1,
        max: 10,
        step: 0.1,
        default: 3.5,
      },
      {
        label: "Steps",
        name: "steps",
        desc: "The number of steps to take in the diffusion process. More steps will generally produce better results but will be slower.",
        min: 1,
        max: 50,
        step: 1,
        default: 4,
      },
      {
        label: "Strength",
        name: "strength",
        desc: "Level of noise added to the initial image",
        min: 0.0,
        max: 1.0,
        step: 0.1,
        default: 0.8,
      },
  ],
  messages: [
    {
      text: "multiple jellyfish floating in a colorful underwater world, depth of field",
      params: {
        "strength": 0.8,
        "guidanceScale": 3.5,
        "steps": 4,
        "seed": 4775002255836,
        "height": 768,
        "width": 1360,
      },
      sender: 'user'
    },
    {
      imageData: {
        image: "/images/showcase/jellyfish.png",
        prompt: "multiple jellyfish with bright, vibrant colors float underwater among the grass, depth of field, boca, jellyfish in foreground, focus, and background"
      },
      sender: 'bot'
    },
  ]
}